var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHpIconProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1163 7.5713C35.5759 7.56534 29.1721 9.44227 23.6698 12.9779C18.1675 16.5135 13.7992 21.5584 11.0869 27.5098C8.37463 33.4613 7.4329 40.0677 8.37424 46.5399C9.31557 53.0122 12.1002 59.0767 16.3954 64.0089C18.6562 60.0525 21.799 56.6709 25.5796 54.127C29.3602 51.5832 33.6766 49.9456 38.1932 49.3418C42.7098 48.738 47.3048 49.1841 51.6209 50.6455C55.9369 52.1069 59.8577 54.5441 63.0784 57.7677C64.9425 59.6208 66.5437 61.7207 67.8371 64.0089C72.1324 59.0767 74.917 53.0122 75.8583 46.5399C76.7996 40.0677 75.8579 33.4613 73.1456 27.5098C70.4333 21.5584 66.0651 16.5135 60.5628 12.9779C55.0604 9.44227 48.6566 7.56534 42.1163 7.5713ZM53.976 31.2908C53.976 34.4362 52.7265 37.4528 50.5024 39.6769C48.2782 41.9011 45.2617 43.1506 42.1163 43.1506C38.9709 43.1506 35.9543 41.9011 33.7302 39.6769C31.506 37.4528 30.2565 34.4362 30.2565 31.2908V28.3259C30.2565 25.1805 31.506 22.1639 33.7302 19.9398C35.9543 17.7156 38.9709 16.4661 42.1163 16.4661C45.2617 16.4661 48.2782 17.7156 50.5024 19.9398C52.7265 22.1639 53.976 25.1805 53.976 28.3259V31.2908Z",
    fill: "url(#paint0_linear_4_2559)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4793 8.65329C27.7069 3.01255 37.7446 0.648081 47.6248 2.02336C57.5051 3.39864 66.5154 8.4145 72.8898 16.0878C79.2641 23.761 82.5427 33.5383 82.083 43.5032C81.6233 53.4682 77.4583 62.9021 70.4046 69.9558C63.3508 77.0096 53.9169 81.1745 43.952 81.6343C33.9871 82.094 24.2097 78.8154 16.5365 72.441C8.86323 66.0667 3.84737 57.0563 2.47209 47.1761C1.09681 37.2958 3.46128 27.2581 9.10202 19.0306M14.5723 12.6411C14.0535 13.1155 13.5643 13.6047 13.0899 14.1236",
    stroke: "#177EC0",
    strokeWidth: 2.96494,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9759 28.3253C53.9759 21.7754 48.6661 16.4656 42.1161 16.4656C35.5661 16.4656 30.2563 21.7754 30.2563 28.3253V31.2903C30.2563 37.8402 35.5661 43.15 42.1161 43.15C48.6661 43.15 53.9759 37.8402 53.9759 31.2903V28.3253Z",
    stroke: "#177EC0",
    strokeWidth: 2.96494,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8369 64.0233C67.8369 64.0233 67.8518 64.0233 67.8369 64.0085C66.5435 61.7203 64.9423 59.6203 63.0782 57.7673C59.8576 54.5437 55.9368 52.1064 51.6207 50.645C47.3046 49.1836 42.7096 48.7375 38.193 49.3414C33.6765 49.9452 29.36 51.5827 25.5794 54.1266C21.7989 56.6704 18.656 60.0521 16.3953 64.0085C16.3804 64.0233 16.3953 64.0233 16.3953 64.0233",
    stroke: "#177EC0",
    strokeWidth: 2.96494,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_2559",
    x1: 1.65206e-7,
    y1: 54,
    x2: 139,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F08C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E34435"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpIconProfile);
export default __webpack_public_path__ + "static/media/hp-icon-profile.392baa0214a98f27efb827eb3e7210f1.svg";
export { ForwardRef as ReactComponent };